import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ARTICLES } from "@/data/blog";
import { useSeo } from "@/lib/seo";

export default function BlogList() {
  useSeo({
    title: "Blog Ozentya — Conseils cheveux afro, crépus & routines",
    description:
      "Astuces cheveux, routines capillaires et conseils pour prendre soin des cheveux afro, crépus et texturés, et développer votre activité de revente Ozentya.",
    path: "/blog",
  });
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-12 md:py-16">
      <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-[var(--oz-gold)] mb-3">
        Le journal Ozentya
      </span>
      <h1 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight text-[var(--oz-text)]">
        Conseils beauté & revente
      </h1>
      <p className="mt-4 text-base text-[var(--oz-muted)] max-w-xl">
        Astuces cheveux, routines et conseils pour développer votre activité à votre rythme.
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {ARTICLES.map((a) => (
          <Link
            key={a.slug}
            to={`/blog/${a.slug}`}
            data-testid={`blog-card-${a.slug}`}
            className="group bg-white rounded-2xl border border-[var(--oz-border)] overflow-hidden hover:-translate-y-1.5 transition-transform"
          >
            <div className="h-52 overflow-hidden">
              <img src={a.cover} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="p-6">
              <div className="text-xs text-[var(--oz-muted)]">{new Date(a.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</div>
              <h2 className="mt-2 font-serif text-xl text-[var(--oz-text)] leading-snug">{a.title}</h2>
              <p className="mt-3 text-sm text-[var(--oz-muted)] leading-relaxed">{a.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--oz-gold)]">
                Lire l'article <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
